export default __webpack_public_path__ + "static/media/swap-success.0895947d.svg";